module.exports = __webpack_public_path__ + "static/media/git.e8926db0.png";